"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdErrorOutline = require("@react-icons/all-files/md/MdErrorOutline");

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _TextArea = require("./TextArea.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TextArea = function TextArea(props) {
  var className = props.className,
      disabled = props.disabled,
      error = props.error,
      id = props.id,
      floatingLabel = props.floatingLabel,
      label = props.label,
      maxLength = props.maxLength,
      _onBlur = props.onBlur,
      _onChange = props.onChange,
      readOnly = props.readOnly,
      rows = props.rows,
      theme = props.theme,
      validations = props.validations,
      value = props.value;

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onBlur'
  }),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register,
      setValue = _getFormMethods.setValue;

  var fieldErrors = error || errors[id];

  var _useState = (0, _react.useState)(value || ''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      textValue = _useState2[0],
      setTextValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var filled = !!textValue && textValue.trim() !== '' && label !== textValue ? 'filled' : '';
  var focusOrFilled = focus || filled;
  var required = (0, _get["default"])(validations, 'required');
  var _theme$textInput$show = theme.textInput.showErrorIcon,
      showErrorIcon = _theme$textInput$show === void 0 ? true : _theme$textInput$show;
  (0, _react.useEffect)(function () {
    setTextValue(value);
    setValue(id, value);
  }, [id, setValue, value]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextArea.StyledTextAreaContainer, {
    className: "".concat(className, " ").concat(fieldErrors ? 'error' : ''),
    disabled: disabled,
    focus: focus,
    floatingLabel: floatingLabel,
    readOnly: readOnly
  }, label && /*#__PURE__*/_react["default"].createElement(_TextArea.StyledTextAreaLabel, {
    disabled: disabled,
    floatingLabel: floatingLabel,
    focusOrFilled: focusOrFilled,
    htmlFor: id,
    rows: rows
  }, label, required && /*#__PURE__*/_react["default"].createElement(_TextArea.StyledTextAreaRequired, {
    disabled: disabled
  }, "*"), !required && /*#__PURE__*/_react["default"].createElement(_TextArea.StyledTextAreaOptional, null, "(Optional)")), /*#__PURE__*/_react["default"].createElement(_TextArea.StyledTextAreaObject, {
    "aria-label": label,
    className: filled,
    disabled: disabled,
    floatingLabel: floatingLabel,
    id: id,
    maxLength: maxLength,
    name: id,
    onBlur: function onBlur(e) {
      _onBlur(e);

      setFocus(false);
    },
    onChange: function onChange(e) {
      _onChange(e);

      setTextValue(e.target.value);
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    readOnly: readOnly,
    ref: register(validations),
    rows: rows
  }), showErrorIcon && fieldErrors && /*#__PURE__*/_react["default"].createElement(_TextArea.StyledAlertIconContainer, {
    floatingLabel: floatingLabel,
    rows: rows
  }, /*#__PURE__*/_react["default"].createElement(_MdErrorOutline.MdErrorOutline, null))), fieldErrors && /*#__PURE__*/_react["default"].createElement(_TextArea.StyledTextAreaError, null, fieldErrors.message));
};

TextArea.defaultProps = {
  className: '',
  disabled: false,
  error: undefined,
  floatingLabel: true,
  maxLength: null,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  readOnly: false,
  rows: 2,
  validations: null,
  value: ''
};
TextArea.propTypes = {
  /** Apply custom class name to the container */
  className: _propTypes.string,

  /** Sets text area disabled state */
  disabled: _propTypes.bool,

  /** For passing external errors to the component */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /** Determines if label should float */
  floatingLabel: _propTypes.bool,

  /** Input field unique identifier */
  id: _propTypes.string.isRequired,

  /** Input label */
  label: _propTypes.string.isRequired,

  /** Maximum number of characters allowed on the field */
  maxLength: _propTypes.number,

  /** Function to be called when focus is removed from the text input */
  onBlur: _propTypes.func,

  /** Function to be called when the text input value is changed */
  onChange: _propTypes.func,

  /** Sets text area readonly state */
  readOnly: _propTypes.bool,

  /** Vertical lines of input text displayed. Minimum 2. */
  rows: function rows(props, propName, componentName) {
    var rows = props.rows;

    if (typeof rows !== 'number') {
      return new Error("Invalid type of ".concat(propName, " supplied to ").concat(componentName, ". Validation failed."));
    }

    if (rows < 2) {
      return new Error("Invalid type of ".concat(propName, " supplied to ").concat(componentName, ". Validation failed. Use TextInput Instead."));
    }

    return null;
  },

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    maxLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    minLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    pattern: (0, _propTypes.shape)({
      value: (0, _propTypes.instanceOf)(RegExp),
      message: _propTypes.string
    }),
    validate: (0, _propTypes.shape)({})
  }),

  /** Initial value */
  value: _propTypes.string
};
TextArea.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextArea",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Apply custom class name to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets text area disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "For passing external errors to the component",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "floatingLabel": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Determines if label should float",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Maximum number of characters allowed on the field",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when focus is removed from the text input",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when the text input value is changed",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets text area readonly state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "rows": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "description": "Vertical lines of input text displayed. Minimum 2.",
      "type": {
        "name": "custom",
        "raw": "(props, propName, componentName) => {\r\n  const { rows } = props;\r\n  if (typeof rows !== 'number') {\r\n    return new Error(`Invalid type of ${propName} supplied to ${componentName}. Validation failed.`);\r\n  }\r\n\r\n  if (rows < 2) {\r\n    return new Error(\r\n      `Invalid type of ${propName} supplied to ${componentName}. Validation failed. Use TextInput Instead.`\r\n    );\r\n  }\r\n\r\n  return null;\r\n}"
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "maxLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "minLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "pattern": {
            "name": "shape",
            "value": {
              "value": {
                "name": "instanceOf",
                "value": "RegExp",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Initial value",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "Input field unique identifier",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "label": {
      "description": "Input label",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(TextArea);

exports["default"] = _default;